import { assignSafe } from '@summit/core';

export class SummitConfirmConfig {
  confirmType?: 'add' | 'delete' | 'default' = 'default';
  title?: string;
  name?: string;
  question?: string;
  action?: string;
  cancel?: string;
  explanation?: string;

  constructor(init?: Partial<SummitConfirmConfig>) {
    assignSafe(this, init);
  }
}
